import { GetBasketQuery } from '@generated/gql/graphql';
import { formatBasket } from '@utils/formatBasket';

const useFormatBasket = (data: Nullable<GetBasketQuery>) => {
  const formattedBasket = formatBasket({
    basket: data?.basket ?? null,
    attributionDetails: data?.attributionDetails ?? null,
  });

  return { formattedBasket };
};

export { useFormatBasket };
